import * as Yup from 'yup';
import messages from './resetPasswordForm.messages';
import { RESET_PASSWORD_FIELDS as FIELDS } from '../../../modules/auth/auth.constants';

export const defaultValues = {
  [FIELDS.email]: '',
};

export const ResetPasswordSchema = Yup.object().shape({
  [FIELDS.email]: Yup.string()
    .email(messages.incorrectEmailFormat)
    .required(messages.fieldRequired),
});
